import React from 'react';
import PaletteOutlinedIcon from '@mui/icons-material/PaletteOutlined';

import ToolbarColorPicker from '@/shared/components/ToolbarColorPicker';

// ---------------------------------------------------------------------------
// Props
// ---------------------------------------------------------------------------

interface ToolbarSlideBackgroundProps {
  color: string;
  onChange: (color: string) => void;
}

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

const ToolbarSlideBackground: React.FC<ToolbarSlideBackgroundProps> = ({ color, onChange }) => (
  <ToolbarColorPicker
    value={color}
    onChange={onChange}
    label="Background"
    icon={<PaletteOutlinedIcon fontSize="small" />}
  />
);

export default ToolbarSlideBackground;
